import { render } from "./ScheduleInfo.vue?vue&type=template&id=54fa56ca"
import script from "./ScheduleInfo.vue?vue&type=script&lang=js"
export * from "./ScheduleInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__